import * as THREE from "three";
import { hash } from "../systems/math";
import { tokens } from "../brand/tokens";
import type { QualityPreset } from "../systems/quality";

export class VaporField {
  readonly group: THREE.Points;
  private positions: Float32Array;
  private time = 0;

  constructor(quality: QualityPreset) {
    if (!quality.enableVapor || quality.particleScale <= 0) {
      this.positions = new Float32Array(0);
      this.group = new THREE.Points();
      return;
    }

    const count = quality.tier === "A" ? 120 : 60;
    this.positions = new Float32Array(count * 3);
    for (let i = 0; i < count; i += 1) {
      this.positions[i * 3] = (hash(i * 1.7) - 0.5) * 4;
      this.positions[i * 3 + 1] = (hash(i * 2.9) - 0.5) * 2.5;
      this.positions[i * 3 + 2] = (hash(i * 4.1) - 0.5) * 2;
    }

    const geo = new THREE.BufferGeometry();
    geo.setAttribute("position", new THREE.BufferAttribute(this.positions, 3));
    const mat = new THREE.PointsMaterial({
      color: tokens.leaf,
      size: 0.04,
      transparent: true,
      opacity: 0.14,
      depthWrite: false,
      blending: THREE.AdditiveBlending,
    });
    this.group = new THREE.Points(geo, mat);
    this.group.name = "Vapor";
  }

  update(dt: number) {
    if (!this.group.geometry) return;
    this.time += dt;
    const attr = this.group.geometry.getAttribute("position") as THREE.BufferAttribute;
    for (let i = 0; i < attr.count; i += 1) {
      const y = this.positions[i * 3 + 1] + Math.sin(this.time * 0.4 + i * 0.2) * 0.002;
      attr.setY(i, y);
    }
    attr.needsUpdate = true;
  }

  dispose() {
    this.group.geometry?.dispose();
    (this.group.material as THREE.Material | undefined)?.dispose();
  }
}
